export enum HeroTypes {
    LatestPlayer= 'latest-player',
    Show = 'show-banner',
    ExternalLink = 'external-link-banner',
    InternalLink = 'internal-link-banner',
    Media = 'media-banner'
}
